/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для списка контактов в кабинете
   */
  app.UserDataContactListView = app.View.extend({
    contacts: [],
    /**
     * @param integer Количество успешных обработок телефона
     */
    successesCount: 0,
    /**
     * @param integer Количество необходимых успешных обработок телефона
     */
    reqQuantityOfSuccesses: 0,

    run: function () {
      var that = this;
      var view;

      this.collection.each(function (model) {
        view = that.contacts[that.contacts.length] = new app.UserDataContactView(
          {
            model: model,
            collection: that.collection,
            el: '[data-user-contact-id=' + model.id + ']'
          }
        );
        view.on('error-user-contact-view', that.triggerError);
      });
    },

    triggerError: function () {
      this.trigger('error-user-data-contact-list-view');
    },

    save: function () {
      var that = this;

      this.successesCount = 0;
      that.reqQuantityOfSuccesses = Object.keys(this.contacts).length;
      if (that.reqQuantityOfSuccesses === 0) {
        this.trigger('success-user-data-contact-list-view');
      }
      this.contacts.forEach(function (view, index, array) {
        if (view.removed) {
          view.off('remove-user-contact-view', that.sendSuccess, that);
          view.on('remove-user-contact-view', that.sendSuccess, that);
          view.removeModel();
          delete(array[index]);
        } else {
          view.off('success-user-contact-view', that.sendSuccess, that);
          view.on('success-user-contact-view', that.sendSuccess, that);
          view.save();
        }
      });
    },

    sendSuccess: function () {
      this.successesCount++;

      if (this.successesCount === this.reqQuantityOfSuccesses) {
        this.successesCount = 0;
        this.trigger('success-user-data-contact-list-view');
      }
    },
    /**
     * Отмена изменений.
     */
    restore: function () {
      /**
       * @param app.UserPhoneView view
       */
      var view;
      var that = this;

      this.$el.html('');
      this.contacts.forEach(function (view, index, array) {
        view.remove();
        if (!view.model.get('id')) {
          view.removeModel();
        }
        delete(array[index]);
      });
      this.contacts = [];

      this.collection.each(function (model) {
        model.set(model.previousAttributes());
        view = that.contacts[that.contacts.length] = new app.UserDataContactView({
          model: model
        });

        that.$el.append(view.render().$el);
      });
    },
    /**
     * Добавляет контакт.
     */
    addContact: function () {
      /** @param app.UserDataContactView view */
      var view;
      /** @param app.UserContact model */
      var model = new app.UserContact();
      model.set('user_id', app.user.id);
      model.set('contact_type_id', app.CONTACT_TYPES.phone);
      this.collection.add(model);
      view = this.contacts[this.contacts.length] = new app.UserDataContactView({model: model, collection: this.collection});
      this.$el.append(view.render().el);
    }
  });
})(jQuery);

}.call(window));